import Cookies from 'universal-cookie';

const cookies = new Cookies();

class DashBoardFinderApi {
    static protocol = 'https';
    static PORT = '3003';


    static async request(baseurl, endpoint, data = {}, method = 'GET') {
        const url = new URL(`${this.protocol}://${baseurl}:${this.PORT}/${endpoint}`);
        const body =  method !== 'GET' ? JSON.stringify(data) : undefined
        url.search = method === 'GET' ? new URLSearchParams(data).toString() : '';

        const headers = {
            'clientToken': `${cookies.get('clientToken') || ''}`,
            'Cache-Control': 'no-cache',
            'Content-Type':'application/json',
            'Accept' : 'application/json'
        };
        try {
            const response = await fetch(url, {method, headers, body});
            console.log('Response Status:', response.status);

            if (!response.ok) {
                const errorResponse = await response.json();
                throw new Error(`API Error: ${errorResponse.message || response.statusText}`);
            }
            return await response.json();
        } catch (error) {
            console.error('Fetch Error:', error.message);
            throw error;
        }
    }

    static async getDashboard(baseurl, endpoint, data) {
        try {
        let resp = await this.request(baseurl, endpoint, data, 'POST');

        const headerName = resp.data.data.lastTwoMonths.headerName;
        const allChartsData = resp.data.data.lastTwoMonths.seriesData.map(reportData => {
          const monthNames = Object.keys(reportData.data);
          const currentMonth = monthNames[0];
          const previousMonth = monthNames[1];

          const currentMonthData = reportData.data[currentMonth];
          const previousMonthData = reportData.data[previousMonth];
          const weeks = resp.data.data.lastTwoMonths.categories;
          const chartType = reportData.type;

          return {
            name: reportData.name,
            monthNames,
            currentMonth: currentMonthData,
            previousMonth: previousMonthData,
            weeks,
            type: chartType,
          };
        });

        const overallDashboardData = {
          categoryCounts: resp.data.data.categoryData,
          totalCounts: resp.data.data.totalCounts,
          rewardCounts: resp.data.data.bannerData,
          lastUpdated: resp.data.data.lastUpdated,
          permissions: resp.data.permissions,
          lastTwoMonthsCounts: {
            headerName,
            data: allChartsData
          }
        };
        
        return {
            apiResp : resp.data,
            cacheProviderValue: overallDashboardData
        } 
    }catch (error) {
            console.error("Error fetching dashboard data:", error);
            throw error;
        }
    }


    static async getProductionStatistics(baseurl, endpoint, data) {
        try{
        let resp = await this.request(baseurl, endpoint, data);
        return resp?.data;
        }catch(error){
            console.error("Error fetching production statistics:", error);
        }
    }
}

export default DashBoardFinderApi;
